import React from 'react';
import { Helmet } from 'react-helmet';
import './pc.less';
import HeroSection from '../../components/HeroSection';
import FeatureGrid from '../../components/FeatureGrid';
import TechShowcase from '../../components/TechShowcase';
import UseCases from '../../components/UseCases';
import VideoDemo from '../../components/VideoDemo';
import PricingSection from '../../components/PricingSection';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>IDEVault · 企业级专有云研发与安全协作平台</title>
        <meta
          name="description"
          content="IDEVault 企业级私有化云端研发平台，提供开箱即用的云端工作间，原生支持 VS Code、JupyterLab 与本地 IDE 双模开发，预装 Codex 与 Steerable 双 AI 智能体，内置项目级外包限期授权、五层数据防泄漏（DLP）与等保合规审计。"
        />
        <meta
          name="keywords"
          content="IDEVault,企业云端研发平台,云端IDE,私有化部署,外包研发安全,数据防泄漏DLP,AI编程智能体,Codex,Steerable,远程开发"
        />
        <link rel="canonical" href="https://idevault.com" />
      </Helmet>

      <main className="home-container" itemScope itemType="https://schema.org/SoftwareApplication">
        <div className="ambient-glow top-glow" aria-hidden="true" />

        <section className="hero-section" aria-label="产品概览">
          <div className="section-inner">
            <HeroSection />
          </div>
        </section>

        <section className="video-section" id="video-demo" aria-label="产品实机演示">
          <div className="section-inner">
            <VideoDemo />
          </div>
        </section>

        <section className="features-section" id="features" aria-labelledby="features-title">
          <div className="section-inner">
            <div className="section-header">
              <span className="section-eyebrow">六大平台能力域 · PLATFORM CAPABILITIES</span>
              <h2 id="features-title">全栈云端研发与企业治理闭环</h2>
              <p>
                围绕「研发工作、AI 辅助、项目治理、安全合规、插件生态、资源运维」六大模块，兼顾开发者流畅体验与企业安全底座
              </p>
            </div>
            <FeatureGrid />
          </div>
        </section>

        <section className="tech-section" id="tech" aria-labelledby="tech-title">
          <div className="section-inner">
            <div className="section-header">
              <span className="section-eyebrow">核心技术壁垒 · ARCHITECTURE DEEP DIVE</span>
              <h2 id="tech-title">核心技术架构深度解析</h2>
              <p>从主容器原生智能体网关、等保三级纵深防御到五层标准镜像预热，构建高可靠研发底座</p>
            </div>
            <TechShowcase />
          </div>
        </section>

        <section className="use-cases-section" id="use-cases" aria-labelledby="use-cases-title">
          <div className="section-inner">
            <div className="section-header">
              <span className="section-eyebrow">行业落地实践 · ENTERPRISE SCENARIOS</span>
              <h2 id="use-cases-title">典型企业应用场景</h2>
              <p>专为对源码资产安全、内网离线合规、AI 赋能可控与环境标准化有严苛要求的研发组织打造</p>
            </div>
            <UseCases />
          </div>
        </section>

        <section className="deployment-section" id="deployment" aria-labelledby="deployment-title">
          <div className="section-inner">
            <div className="section-header">
              <span className="section-eyebrow">离线一键交付 · PRIVATE DEPLOYMENT</span>
              <h2 id="deployment-title">灵活的私有化部署与交付形态</h2>
              <p>Ed25519 签名离线安装包交付，支持从单机快速验证到多集群生产级扩容，装完即用</p>
            </div>
            <PricingSection />
          </div>
        </section>
      </main>
    </>
  );
};

export default Home;
